import React, { Component } from 'react';

const typeCapacity = [
    { title: 'Interno', value: ''},
    { title: 'Pedido', value: ''},
    { title: 'Comprometidos', value: ''},
    { title: 'Consumidos', value: ''},
    { title: 'Disponible', value: ''},
    { title: 'Todos', value: ''},
];

const headersBody = [
    { title: "#", class: 'sticky-column'},
    { title: "N° de recurso", value: true},
    { title: "Desc. recurso", value: true},
    { title: "Almacén", value: true},
    { title: "Total", value: true},
];

class ContentRscCapacity extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    renderHeader = () => {
        const { action, openPropertiesModal } = this.props;
        return(
            <div className="row">
                <div className="col-md-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de capacidad</span>
                        </div>
                        <select 
                            type="text" 
                            className="form-control"
                            name="type" 
                            disabled={action === 2}>
                                {typeCapacity.map(opt => {return (<option value={opt.value}>{opt.title}</option>)})}
                        </select>
                    </div>
                </div>
                <div className='col-md-1'>
                    <div className="input-group-prepend">
                        <button  className='btn btn-secondary'>+</button>
                    </div>
                </div>
                <div className='col-md-3'>
                    <input 
                        type="text" 
                        className="form-control"
                        value={'0.000'} 
                        disabled={action === 2}/>
                </div>
                <div className='col-md-1'>
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">%</span>
                    </div>
                </div>
                <div className='col-md-1'>
                    <div className="input-group-prepend">
                        <button className='btn btn-secondary'>-</button>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Periodo de capacidad</span>
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <button className="btn btn-secondary"><i className="fas fa-arrow-left"></i></button>           
                        </div>  
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                        </div>
                        <input 
                            type="date" 
                            className="form-control"
                            disabled={action === 2}/>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                        </div>
                        <input 
                            type="date" 
                            className="form-control"
                            disabled={action === 2}/>
                        <div className="input-group-prepend">
                            <button className="btn btn-secondary"><i className="fas fa-arrow-right"></i></button>           
                        </div>
                    </div>     
                </div>
                <div className="col-md-6">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Código de almacen</span>
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                        </div>
                        <input 
                            type="text" 
                            className="form-control"
                            disabled={action === 2}/>
                        {action === 1 &&
                            <button
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text">
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        }
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                        </div>
                        <input 
                            type="text" 
                            className="form-control"
                            disabled={action === 2}/>
                        {action === 1 &&
                            <button
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text">
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        }
                    </div>   
                </div>
                <div className="col-md-6">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Número de recurso</span>
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                        </div>
                        <input 
                            type="text" 
                            className="form-control"
                            disabled={action === 2}/>
                        {action === 1 &&
                            <button
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text">
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        }
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                        </div>
                        <input 
                            type="text" 
                            className="form-control"
                            disabled={action === 2}/>
                        {action === 1 &&
                            <button
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text">
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        }
                    </div>   
                </div>  
                <div className="col-md-6">
                    <div className="input-group-prepend">
                        <span className="input-group-text font-weight-bold" id="basic-addon1">Grupo de recursos</span>
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Desde</span>
                        </div>
                        <select 
                            type="text" 
                            className="form-control"
                            disabled={action === 2}>
                                <option value=''></option>
                                <option value=''>Recursos</option>
                        </select>
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Hasta</span>
                        </div>
                        <select 
                            type="text" 
                            className="form-control"
                            disabled={action === 2}>
                                <option value=''></option>
                                <option value=''>Recursos</option>
                        </select>
                    </div>   
                </div>
                <div className="col-md-6"> 
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tipo de recurso</span>
                        </div>
                        <select 
                            type="text" 
                            className="form-control"
                            disabled={action === 2}>
                                <option value=''></option>
                                <option value=''>Máquina</option>
                                <option value=''>Trabajo</option>
                                <option value=''>Otros</option>
                        </select>
                    </div> 
                </div>
                <div className="col-md-6"> 
                </div>  
                <div className="col-md-6"> 
                    <div className="input-group mb-3">
                        <button className="btn btn-secondary" onClick={() => openPropertiesModal()}>Propiedades de recursos</button>                                   
                    </div> 
                </div>  
                <div className="col-md-4"> 
                    <div className="input-group mb-3">
                        <input 
                            type="text" 
                            className="form-control"
                            disabled="true"
                            value="Ignorar"
                        />                    
                    </div> 
                </div> 
                <div className="col-md-2"> 
                    <div className="input-group mb-3 justify-content-end">
                        <button className="btn btn-secondary">Actualizar</button>                                   
                    </div> 
                </div> 
            </div>   
        ); 
    }

    renderBody = () => {
        const { action } = this.props;
        return (
            <div style={{ marginBottom: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className={"nav-item nav-link font-weight-bold text-secondary"}
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                    </div>
                </nav>
    
                <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                    {/* CONTENIDO */}
                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }}
                    >
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center"}}>
                                    {headersBody.map((header, index) => {
                                        return (
                                            <td key={index} className={`${header.class ?? ''} sticky-header`} style={{ background: "#d2ab24" }}>{header.title}</td>    
                                        );
                                    })}                     
                                </tr>
                            </thead>
                            <tbody>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    renderFooter = () => {
        const { action} = this.props;
        return (
            <div className="row pr-0">
                <div className="col-sm-5">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text form-check">
                                <input
                                    type="checkbox"
                                    disabled={action === 2}/>
                            </span>
                        </div>
                        <label className="form-control">Mostrar capacidad acumulada desde hoy</label>
                    </div>
                </div>
            </div>
        );
    }

    render () {
        const { render } = this.props;
        let content = '';
        switch (render) {
            case 'header':
                content = this.renderHeader();
                break;
            case 'body':
                content = this.renderBody();
                break;
            case 'footer':
                content = this.renderFooter();
                break;
            default:
                content = '';
        }

        return (
            <div className='Content'>
                {content}
            </div>
        );
    }
}

export default ContentRscCapacity;